import React from 'react';
import PropTypes from 'prop-types';
import { SeeAllLinkVariants } from './constants';
import * as S from './styled';

const fn = () => {
  /* empty */
};
export const SeeAllLink = ({
  text = 'See all',
  icon = <S.ArrowIcon />,
  disabled = false,
  variant = SeeAllLinkVariants.REGULAR,
  onClick = fn,
  testId = 'seeAllBtn'
}) => (
  <S.ButtonLinked testId={testId} disabled={disabled} $variant={variant} onClick={onClick} endIcon={icon}>
    {text}
  </S.ButtonLinked>
);

SeeAllLink.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.node,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(Object.values(SeeAllLinkVariants)),
  onClick: PropTypes.func,
  testId: PropTypes.string
};
